import {EmptyString} from 'Core/models/EmptyString';
import * as O from 'fp-ts/lib/Option';
import {
  InitialPolicyServiceRequest,
  InvalidInitialPolicyServiceRequest,
} from 'Agent/Policies/models/ServiceRequest/InitialPolicyServiceRequest';
import {PolicyServiceRequestWithChangeRequest} from 'Agent/Policies/models/ServiceRequest/PolicyServiceRequestWithChangeRequest';

export type PolicyServiceRequest = InitialPolicyServiceRequest | PolicyServiceRequestWithChangeRequest;

type PolicyServiceRequestOptions<TReturn> = {
  Initial: (intial: InitialPolicyServiceRequest) => TReturn;
  WithChangeRequest: (withChangeRequest: PolicyServiceRequestWithChangeRequest) => TReturn;
};

export const EmptyPolicyServiceRequest: PolicyServiceRequest = new InvalidInitialPolicyServiceRequest(
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  [],
  O.none
);

export const matchPolicyServiceRequest = <TReturn>(
  serviceRequest: PolicyServiceRequest,
  options: PolicyServiceRequestOptions<TReturn>
) => {
  switch (serviceRequest.key) {
    case 'InvalidInitialPolicyServiceRequest':
    case 'ValidInitialPolicyServiceRequest':
      return options.Initial(serviceRequest);
    case 'ValidPolicyServiceRequest':
    case 'InvalidPolicyServiceRequestWithChangeRequest':
      return options.WithChangeRequest(serviceRequest);
  }
};
